export default __webpack_public_path__ + "static/media/P316.1.493712e3.mp3";